var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Language, pendoAPIKey, RoutePath, SYSTEM_ID } from 'constants/app.constant';
import { Component } from 'react';
import { appActions, appSelectors } from 'redux/ducks/app';
import { connect } from 'react-redux';
import { ELSLoggingService, ELSPendoService } from '@els/els-ui-common-react';
import { routerSelectors } from 'redux/ducks/route';
import { courseSelectors } from 'reports/cw/redux/ducks/courses';
import { hadSelectors } from 'reports/had/redux/ducks/had';
import { SH_PATHS } from 'reports/sh/constants/sh.constant';
import { shSelectors } from 'reports/sh/redux/ducks/sh';
import { checkPathMatchV2 } from 'helpers/app.helper';
import { PS_PATHS } from 'reports/ps/constants';
var PendoInit = /** @class */ (function (_super) {
    __extends(PendoInit, _super);
    function PendoInit(props) {
        var _this = _super.call(this, props) || this;
        // ToDo: data manipulation logic here is shared with AdobeAnalyticsInit. Move to a parent component
        _this.initializePendo = function (props) {
            var _a, _b, _c, _d, _e;
            var courseSectionInfo = props.courseSectionInfo, evolveUser = props.evolveUser, evolveUserLoading = props.evolveUserLoading, evolveUserHasBeenCalled = props.evolveUserHasBeenCalled, isbn = props.isbn, isPendoAlreadyIntialized = props.isPendoAlreadyIntialized, programId = props.programId, programName = props.programName, userId = props.userId, userRole = props.userRole, fetchEvolveUser = props.fetchEvolveUser, instructorId = props.instructorId;
            var windowPage = (_a = window === null || window === void 0 ? void 0 : window.pageData) === null || _a === void 0 ? void 0 : _a.page;
            var courseId = ((_b = courseSectionInfo === null || courseSectionInfo === void 0 ? void 0 : courseSectionInfo.id) === null || _b === void 0 ? void 0 : _b.toString()) || '';
            var prefix = SYSTEM_ID.EVOLVE;
            var accountId = ((_d = (_c = courseSectionInfo === null || courseSectionInfo === void 0 ? void 0 : courseSectionInfo.institution) === null || _c === void 0 ? void 0 : _c.id) === null || _d === void 0 ? void 0 : _d.toString()) || '';
            var accountName = ((_e = courseSectionInfo === null || courseSectionInfo === void 0 ? void 0 : courseSectionInfo.institution) === null || _e === void 0 ? void 0 : _e.name) || '';
            if (userId && !evolveUser && !evolveUserLoading && !evolveUserHasBeenCalled) {
                fetchEvolveUser(userId);
            }
            var isUserHaveEvolveData = evolveUser || checkPathMatchV2(Object.values(SH_PATHS));
            if (isPendoAlreadyIntialized || !userId || !userRole || !isUserHaveEvolveData) {
                return;
            }
            var pendo = window.pendo, pageData = window.pageData, pageDataTracker = window.pageDataTracker;
            if (!pendo || !pageData || !pageDataTracker) {
                // Taking a bit of a race condition risk here checking for pendo, pageData, and pageDataTracker
                // These checks will not initiate a componentDidUpdate lifecycle when they are initialized so if
                // they are not here when we run this function there is a chance we never initialize pendo
                ELSLoggingService.warn('PendoInit', 'Failed to initialize Pendo: missing window.pendo || window.pageData || window.pageDataTracker');
                return;
            }
            var locationHash = window.location.hash.toLowerCase();
            // if we're on NCLEX, we might not have institution id, so we need to use program id
            if (locationHash === "#".concat(RoutePath.had.toLowerCase())) {
                accountId = !accountId ? programId.toString() : accountId;
                accountName = !accountName ? programName : accountName;
            }
            // if we're on SH, we might not have institution id, so we need to use instructor id
            if (checkPathMatchV2(Object.values(SH_PATHS))) {
                accountId = accountId || (instructorId === null || instructorId === void 0 ? void 0 : instructorId.toString());
                accountName = accountName || 'shadowhealth-user';
            }
            // if we're on Reporting Portal or PSD page, we might not have institution id and institution name, so we need to use user id and user name
            if (!accountId && !accountName && checkPathMatchV2(__spreadArray(__spreadArray([], Object.values(PS_PATHS), true), [RoutePath.reportingPortal], false))) {
                accountId = userId;
                accountName = evolveUser === null || evolveUser === void 0 ? void 0 : evolveUser.userName;
            }
            if (!accountId || !accountName) {
                return;
            }
            window.pendo.initialize({
                visitor: {
                    accessType: userRole,
                    courseId: courseId,
                    id: "".concat(prefix, ":").concat(evolveUser === null || evolveUser === void 0 ? void 0 : evolveUser.externalUserId),
                    isbn: isbn,
                    pageEnvironment: windowPage === null || windowPage === void 0 ? void 0 : windowPage.environment,
                    pageLanguage: Language.DEFAULT_LOCALE,
                    pageProduct: windowPage === null || windowPage === void 0 ? void 0 : windowPage.productName,
                    webuserID: "".concat(prefix, ":").concat(evolveUser === null || evolveUser === void 0 ? void 0 : evolveUser.externalUserId)
                },
                account: {
                    id: "".concat(prefix, ":").concat(accountId),
                    name: "".concat(prefix, ":").concat(accountName)
                }
            });
            _this.setState({ isPendoAlreadyIntialized: true });
        };
        _this.state = {
            isPendoAlreadyIntialized: false,
            isPendoScriptInjected: false
        };
        return _this;
    }
    PendoInit.prototype.componentDidMount = function () {
        var _this = this;
        if (!this.state.isPendoScriptInjected && pendoAPIKey) {
            ELSPendoService.injectScript(pendoAPIKey).then(function () {
                _this.setState({ isPendoScriptInjected: true });
            });
        }
    };
    PendoInit.prototype.componentDidUpdate = function () {
        if (this.state.isPendoScriptInjected && !this.state.isPendoAlreadyIntialized) {
            this.initializePendo(this.props);
        }
    };
    PendoInit.prototype.render = function () {
        return null;
    };
    return PendoInit;
}(Component));
var mapStateToProps = function (state) { return ({
    courseSectionInfo: courseSelectors.getCourseSectionInfo(state),
    evolveUser: appSelectors.getEvolveUser(state),
    evolveUserLoading: appSelectors.getEvolveUserLoading(state),
    evolveUserHasBeenCalled: appSelectors.getEvolveUserHasBeenCalled(state),
    featureFlags: appSelectors.getFeatureFlags(state),
    isbn: appSelectors.getIsbn(state),
    location: routerSelectors.getLocation(state),
    programId: hadSelectors.getProgramId(state),
    programName: hadSelectors.getProgramName(state),
    userId: appSelectors.getUserId(state),
    userRole: appSelectors.getUserRole(state),
    instructorId: shSelectors.getInstructorId(state)
}); };
var mapDispatchToProps = function (dispatch) { return ({
    fetchEvolveUser: function (userId) { return dispatch(appActions.fetchEvolveUser(userId)); }
}); };
export default connect(mapStateToProps, mapDispatchToProps)(PendoInit);
